import React from "react";
import { SvgIcon } from "@material-ui/core";

export const AiSingleStarIcon = (props) => (
	<SvgIcon {...props}>
		<path d="M12 3l2.5 7.5L22 13l-7.5 2.5L12 23l-2.5-7.5L2 13l7.5-2.5z" />
	</SvgIcon>
);
